import script from "./Benefits.vue?vue&type=script&setup=true&lang=js"
export * from "./Benefits.vue?vue&type=script&setup=true&lang=js"

import "./Benefits.vue?vue&type=style&index=0&id=3cccc72a&lang=scss&scoped=true"
import "./Benefits.vue?vue&type=style&index=1&id=3cccc72a&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3cccc72a"]])

export default __exports__